import { TypedEmitter } from "tiny-typed-emitter";

import Game from "./Game";
import Phys from "./Phys";

export interface BouncerEvents {
  bounce: () => void;
  bounceGround: () => void;
}

export default class Bouncer extends TypedEmitter<BouncerEvents> {
  game: Game;

  px: number;
  py: number;
  ox: number;
  oy: number;
  frict: number;
  sp: Phys;
  parc: number = 0;

  constructor(sprite: Phys) {
    super();

    this.game = sprite.game;

    this.sp = sprite;
    this.px = Math.floor(this.sp.x);
    this.py = Math.floor(this.sp.y);
    this.ox = 0.5;
    this.oy = 0.5;
    this.frict = 1;
  }

  setPos(x: number, y: number) {
    this.px = Math.floor(x);
    this.py = Math.floor(y);
    this.sp.x = x;
    this.sp.y = y;
  }

  update() {
    this.parc = 1;
    let vvx = this.sp.vx;
    let vvy = this.sp.vy;
    if (vvx == 0 && vvy == 0) this.parc = 0;

    while (this.parc > 0) {
      let cx: number | null = null;
      let cy: number | null = null;

      if (vvx > 0) {
        cx = (1 - this.ox) / vvx;
      } else if (vvx < 0) {
        cx = this.ox / vvx;
      } else {
        cx = 1;
      }

      if (vvy > 0) {
        cy = (1 - this.oy) / vvy;
      } else if (vvy < 0) {
        cy = this.oy / vvy;
      } else {
        cy = 1;
      }

      let c: number | null = null;
      let sx: number | null = null;
      let sy: number | null = null;
      if (Math.abs(cx) < Math.abs(cy)) {
        c = Math.abs(cx);
        sx = Math.floor(cx / c);
      } else {
        c = Math.abs(cy);
        sy = Math.floor(cy / c) ?? 1;
      }

      let flCheck = true;
      if (c > this.parc) {
        c = this.parc;
        flCheck = false;
      }
      this.ox += vvx * c;
      this.oy += vvy * c;
      this.parc -= c;

      if (flCheck) {
        if (sx != null) {
          if (this.game.level.isFree(this.px + sx, this.py)) {
            this.px += sx;
            this.ox -= sx;
          } else {
            this.emit("bounce");
            vvx *= -this.frict;
            this.sp.vx *= -this.frict;
          }
        }
        if (sy != null) {
          if (this.game.level.isFree(this.px, this.py + sy)) {
            this.py += sy;
            this.oy -= sy;
          } else {
            this.emit("bounce");
            vvy *= -this.frict;
            this.sp.vy *= -this.frict;
            if (this.sp.vy < 0) this.emit("bounceGround");
          }
        }
      }
    }

    this.sp.x = this.px + this.ox;
    this.sp.y = this.py + this.oy;
  }
}
